import { NATIVE_TOKEN_ADDRESS } from "../../../../../constants/addresses.js";
export const NATIVE_TOKEN = { nativeToken: true };
/**
 * @internal
 */
export function isNativeToken(token) {
    return ("nativeToken" in token ||
        token.address?.toLowerCase() === NATIVE_TOKEN_ADDRESS.toLowerCase());
}
//# sourceMappingURL=nativeToken.js.map